import React from "react";
import CustomPosReceipt from "../../../../partials/content/CustomPosReceipt";
const PosReceipt = ({ salesData, outletData, userName = "" }) => {
  return (
    <React.Fragment>
      <CustomPosReceipt
        salesData={salesData}
        outletData={outletData}
        userName={userName}
      />
    </React.Fragment>
  );
};

export default PosReceipt;
